<template>
  <div id="accountDisabled" class="account-disabled">
    <h2>Account Disabled</h2>
    <div>
      <p>Your account has been disabled</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account-disabled',
  title: 'Account Disabled',
  data: function() {
    return {};
  },
  methods: {},
};
</script>
